import * as React from 'react';
import { FileSelector } from 'ui';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import { TextConfigurationTranslation } from '../../constants';

import styles from './text-import.scss';

export interface TextImportProps {
  fetching: boolean;
  onClose: () => void;
  onDone: (file: File, startMessage: string, successMessage: string, errorMessage: string, errorHandler: () => void,
    reloadFile: string) => void;
  clearImportValidationErrors: () => void;
  translation: TextConfigurationTranslation;
  children?: React.ReactNode;
}

export interface TextImportState {
  file: File;
}
export class TextImport extends React.Component<TextImportProps, TextImportState> {

  public state: Readonly<TextImportState> = {
    file: undefined
  };

  private onSubmit = () => {
    const { onDone, translation } = this.props;

    onDone(this.state.file, translation.import_start, translation.import_ended, translation.import_failed, this.clearFile,
      translation.reload_file);
  };

  private clearFile = () => this.setState({ file: undefined });

  private handleChangeFileUploader = (file: File) => {
    this.setState({ file });
    this.props.clearImportValidationErrors();
  };

  public render() {
    const { fetching, onClose, translation, children } = this.props;
    const disabled = !this.state.file || fetching;

    return (
      <ModalWrapper
        headerTitle={translation.import_file_to_synergi_life}
        btnTitle={translation.import_submit}
        btnCancelTitle={translation.import_cancel}
        canCloseOnBackground={!fetching}
        canCloseOnXButton={!fetching}
        onDone={this.onSubmit}
        closeOnDone={false}
        onClose={onClose}
        isDisabled={disabled}
        isCancelDisabled={disabled}>

        <div className="control-label">
          <span className="asterisk-required">* </span>{translation.upload_file}
        </div>

        <div className={`input-wrapper ${styles.importFileWrapper}`}>
          <FileSelector
            textSelectFile={translation.import_choose_file}
            onSelected={this.handleChangeFileUploader}
            acceptFileTypes={'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
            disabled={fetching}
          />
        </div>

        { fetching ?
          <div className={styles.spinLoaderContainer}>
            <div className={styles.spinLoader} />
          </div>
          : null}

        {children}
      </ModalWrapper >
    );
  }
}
